import { render, staticRenderFns } from "./HeaderBaseMobile.vue?vue&type=template&id=4f2fcab4&scoped=true&"
import script from "./HeaderBaseMobile.vue?vue&type=script&lang=js&"
export * from "./HeaderBaseMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fcab4",
  null
  
)

export default component.exports